import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/grape-varieties/components/GrapeVarietiesInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
